import { Tabs } from "antd";
import React, { useState } from "react";
import CustomerLedger from "../../Inventory/CustomerLedger";
import CustomerBalanceSummary from "./CustomerBalanceSummary";
import CustomerLedgerReport from "./CustomerLedgerReport";
import CorporateLedgerReport from "./CorporateLedgerReport";

export default function MainCustomerLedger() {
  const [tabChange, setTabChange] = useState(null);

  const handleTabChange = (value) => {
    setTabChange(value);
  };
  const items = [
    {
      key: "Customer Ledger/Transaction",
      label: (
        <div className="text-center" style={{ color: "#46604A" }}>
          Customer Ledger/Transaction
        </div>
      ),
      children: <CustomerLedgerReport tabChange={tabChange} />,
    },
    {
      key: "Corporate Ledger/Transaction",
      label: (
        <div className="text-center" style={{ color: "#46604A" }}>
          Corporate Ledger/Transaction
        </div>
      ),
      children: <CorporateLedgerReport tabChange={tabChange} />,
    },
    {
      key: "Customer Balance Summary",
      label: (
        <div className="text-center" style={{ color: "#46604A" }}>
          Customer Balance Summary
        </div>
      ),
      children: <CustomerBalanceSummary tabChange={tabChange} />,
    },
  ];
  return (
    <>
      <div className="shadow-sm rounded">
        <Tabs
          onChange={handleTabChange}
          className="px-4 mt-4 custom-tabs"
          defaultActiveKey="Purchase Order List"
          items={items}
        />
      </div>
    </>
  );
}
